<div class="row">
  <div class="col-12">
    <div class="content-header">Course {{isEdit?'Edit':'Add'}}</div>
    <!-- <p class="content-sub-header mb-1">Configure account settings to your needs.</p> -->
  </div>
</div>
<!-- Account Settings starts -->
<div class="row">
  <div class="col-md-3 mt-3">
    <!-- Nav tabs -->
    <ul class="nav flex-column nav-pills" id="myTab" role="tablist">
      <li class="nav-item">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'basic'}"
          (click)="setActiveTab('basic')" id="basic-tab" data-toggle="tab" role="tab" aria-controls="basic"
          aria-selected="true">
          <i class="ft-settings mr-1 align-middle"></i>
          <span class="align-middle">Basic</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'advance'}"
          (click)="setActiveTab('advance')" id="advance-tab" data-toggle="tab" role="tab" aria-controls="advance"
          aria-selected="false">
          <i class="ft-lock mr-1 align-middle"></i>
          <span class="align-middle">Advance</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'pricing'}"
          (click)="setActiveTab('pricing')" id="pricing-tab" data-toggle="tab" role="tab" aria-controls="pricing"
          aria-selected="false">
          <i class="ft-info mr-1 align-middle"></i>
          <span class="align-middle">Pricing</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'publishing'}"
          (click)="setActiveTab('publishing')" id="publishing-tab" data-toggle="tab" role="tab"
          aria-controls="publishing" aria-selected="false">
          <i class="ft-twitter mr-1 align-middle"></i>
          <span class="align-middle">Publishing</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'team'}"
          (click)="setActiveTab('team')" id="team-tab" data-toggle="tab" role="tab"
          aria-controls="team" aria-selected="false">
          <i class="ft-link mr-1 align-middle"></i>
          <span class="align-middle">Team</span>
        </a>
      </li>
      <li class="nav-item" *ngIf="courseId">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'meta'}" (click)="setActiveTab('meta')"
          id="meta-tab" data-toggle="tab" role="tab" aria-controls="team" aria-selected="false">
          <i class="ft-link mr-1 align-middle"></i>
          <span class="align-middle">Meta Information</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'admin'}"
          (click)="setActiveTab('admin')" id="admin-tab" data-toggle="tab" role="tab"
          aria-controls="admin" aria-selected="false">
          <i class="ft-bell mr-1 align-middle"></i>
          <span class="align-middle">Admin</span>
        </a>
      </li>
    </ul>
  </div>
  <div class="col-md-9">
    <!-- Tab panes -->
    <div class="card">
      <div class="card-content">
        <div class="card-body">
          <div class="tab-content">
            <!-- basic Tab -->
            <div class="tab-pane" [ngClass]="{active: activeTab === 'basic'}" id="basic" role="tabpanel"
              aria-labelledby="basic-tab">
              <div class="media">
                <img *ngIf="!isEdit" [src]="imgUrl?imgUrl:'assets/img/portrait/small/avatar-s-8.png'" (click)="fileInput.click()" alt="profile-img" class="rounded mr-3" height="64"
                  width="64">
                  <img *ngIf="isEdit && !imgUrl"  [src]="imageBaseUrl+fileData" (click)="fileInput.click()" alt="profile-img" class="rounded mr-3" height="64"
                  width="64">  
                  <img *ngIf="isEdit && imgUrl" [src]="imgUrl" (click)="fileInput.click()" alt="profile-img" class="rounded mr-3" height="64"
                  width="64">
                <div class="media-body">
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2">
                    <label class="btn btn-sm bg-light-primary mb-sm-0" for="select-files">{{isEdit?'Change':'Upload'}} Photo</label>
                    <input type="file" id="select-files" #fileInput  (change)="onSelectFile($event)"  hidden>
                    <button class="btn btn-sm bg-light-secondary ml-sm-2" (click)="resetFile()">Reset</button>
                  </div>
                  <p class="text-muted mb-0 mt-1 mt-sm-0">
                    <small>Allowed JPG, GIF or PNG. Max size of 800kB</small>
                  </p>
                </div>
              </div>
              <hr class="mt-1 mt-sm-2">
              <form [formGroup]="basicForm" (ngSubmit)="onBasicFormSubmit()">
                <div class="row">
                  <div class="col-12 form-group">
                    <label for="title">Title<span class="required_field">*</span></label>
                    <div class="controls">
                      <input type="text" formControlName="title" [(ngModel)]="course_model.title" class="form-control" placeholder="Title"
                        [ngClass]="{ 'is-invalid': basicFormSubmitted && bf.title.invalid, 'is-valid': basicFormSubmitted && !bf.title.invalid }"
                        required>
                      <div *ngIf="basicFormSubmitted && (bf.title.invalid || bf.title.errors?.required)"
                        class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                        required</div>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label for="about">About<span class="required_field">*</span></label>
                    <div class="controls">
                      <quill-editor formControlName="about"  [(ngModel)]="course_model.about" [maxLength]="5" [minLength]="3" [required]="true"
                        [modules]="{toolbar: false}"
                        [ngClass]="{ 'ng-invalid-textArea': basicFormSubmitted && bf.about.invalid, 'is-valid': basicFormSubmitted && !bf.about.invalid }"></quill-editor>
                      <div *ngIf="basicFormSubmitted && (bf.about.invalid || bf.about.errors?.required)"
                        class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                        required</div>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label>Course Type<span class="required_field">*</span></label>
                    <ng-select [items]="course_type_List" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Course type" [(ngModel)]="selected_course_type"
                      [ngModelOptions]="{ standalone: true }" (change)="getCourseTypeId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label for="languages">Languages<span class="required_field">*</span></label>
                    <ng-select [multiple]="true" [(ngModel)]="selectedLanguages" [ngModelOptions]="{standalone: true}" placeholder="Select Language">
                      <ng-option *ngFor="let language of languages" [value]="language.value">{{language.name}}
                      </ng-option>
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label for="preliminarye">Preliminary</label>
                    <div class="controls">
                      <quill-editor formControlName="preliminarye" [(ngModel)]="course_model.preliminary" [maxLength]="5" [minLength]="3" [required]="true"
                        [modules]="{toolbar: false}"
                        [ngClass]="{ 'ng-invalid-textArea': basicFormSubmitted && bf.preliminarye.invalid, 'is-valid': basicFormSubmitted && !bf.preliminarye.invalid }"></quill-editor>
                      <div *ngIf="basicFormSubmitted && (bf.preliminarye.invalid || bf.preliminarye.errors?.required)"
                        class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                        required</div>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label>Mode<span class="required_field">*</span></label>
                    <ng-select [items]="mode_List" bindLabel="displayname" bindValue="_id" [multiple]="true" placeholder="Select mode"
                      [(ngModel)]="selected_mode" [ngModelOptions]="{ standalone: true }" (change)="getModeId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label>Duration<span class="required_field">*</span></label>
                    <ng-select [items]="duration_List" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Duration" [(ngModel)]="selected_duration"
                      [ngModelOptions]="{ standalone: true }" (change)="getDurationId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label>Course Category</label>
                    <ng-select [items]="categoryList" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Course Interest" [(ngModel)]="selectedCategory"
                      [ngModelOptions]="{ standalone: true }" (change)="getCategoryId($event)"
                      >
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label>course skills</label>
                    <ng-select [items]="tagsList" bindLabel="displayname" bindValue="_id" [multiple]="true"
                      [closeOnSelect]="false" placeholder="Select Skill" [(ngModel)]="selectedTag"
                      [ngModelOptions]="{ standalone: true }" (change)="getTagsId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label>Variation</label>
                    <ng-select [items]="variationList" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Variation" [(ngModel)]="selectedVariation"
                      [ngModelOptions]="{ standalone: true }" (change)="getVariationId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                    <button type="submit" class="btn btn-primary mr-sm-2 mb-1" (click)="setActiveTab('advance')" >Next</button>
                  </div>
                </div>
              </form>
            </div>

            <!-- advance Tab -->
            <div class="tab-pane" [ngClass]="{active: activeTab === 'advance'}" id="advance" role="tabpanel"
              aria-labelledby="advance-tab">
              <form [formGroup]="advanceForm" (ngSubmit)="onAdvanceFormSubmit()">
                <div class="col-12 form-group">
                  <label for="benifits">Benefits</label>
                  <div class="controls">
                    <quill-editor formControlName="benifits" [(ngModel)]="course_model.benifits"  [maxLength]="5" [minLength]="3"
                      [modules]="{toolbar: false}"></quill-editor>
                  </div>
                </div>
                <div class="col-12 form-group">
                  <label for="learning_audience">Learning Audience</label>
                  <div class="controls">
                    <quill-editor formControlName="learning_audience" [(ngModel)]="course_model.learning_audience" [maxLength]="5" [minLength]="3"
                      [modules]="{toolbar: false}"></quill-editor>
                  </div>
                </div>
                <div class="col-12 form-group">
                  <label for="outcome">Outcome</label>
                  <div class="controls">
                    <quill-editor formControlName="outcome" [(ngModel)]="course_model.outcome" [maxLength]="5" [minLength]="3"
                      [modules]="{toolbar: false}"></quill-editor>

                  </div>
                </div>
                <div class="col-12 form-group">
                  <label for="objective">Objective</label>
                  <div class="controls">
                    <quill-editor formControlName="objective" [(ngModel)]="course_model.objective" [maxLength]="5" [minLength]="3"
                      [modules]="{toolbar: false}"></quill-editor>
                  </div>
                </div>
                <div class="col-12 form-group">
                  <label for="promotional_video">Promotional Video</label>
                  <div class="controls">
                    <input type="text" formControlName="promotional_video" [(ngModel)]="course_model.promotional_video" class="form-control"
                      placeholder="Promotional Video">
                  </div>
                </div>
                <div class="col-12 form-group">
                  <label>Projects</label>
                  <ng-select [items]="project_list" [multiple]="true" bindLabel="name" bindValue="_id" placeholder="Select project"
                    [(ngModel)]="selected_project" [ngModelOptions]="{ standalone: true }"
                    (change)="getProjectId($event)">
                  </ng-select>
                </div>
                <div class="col-12 form-group">
                  <label>Resources</label>
                  <ng-select [items]="resource_list" [multiple]="true" bindLabel="content" bindValue="id"
                    placeholder="Select last publishers" [(ngModel)]="selected_resource"
                    [ngModelOptions]="{ standalone: true }" (change)="getResourceId($event)">
                  </ng-select>
                </div>
                <div class="col-12 form-group">
                  <label for="version">Version</label>
                  <div class="controls">
                    <input type="text" formControlName="version" [(ngModel)]="course_model.version" class="form-control" placeholder="Enter version">
                  </div>
                </div>
                <div class="col-12 form-group">
                  <label>Level</label>
                  <ng-select [items]="level_List" bindLabel="displayname" bindValue="_id" placeholder="Select level"
                    [(ngModel)]="selected_level" [ngModelOptions]="{ standalone: true }" (change)="getLevelId($event)">
                  </ng-select>
                </div>
                <div class="col-12 radio-fields mb-1">
                  <div>
                    <label for="grading">Grading?</label>
                    <ul class="list-unstyled mb-0">
                      <li class="d-inline-block mr-2">
                        <div class="radio">
                          <input type="radio" value="true" name="grading" formControlName="grading" id="gradingYes" [(ngModel)]="course_model.grading" checked />
                          <label for="gradingYes">Yes</label>
                        </div>
                      </li>
                      <li class="d-inline-block mr-2">
                        <div class="radio">
                          <input type="radio" value="false" formControlName="grading" [(ngModel)]="course_model.grading" name="grading" id="gradingNo" />
                          <label for="gradingNo">No</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <label for="certification">Certification?</label>
                    <ul class="list-unstyled mb-0">
                      <li class="d-inline-block mr-2">
                        <div class="radio">
                          <input type="radio" value="true" name="certification" formControlName="certification" id="certificationYes" [(ngModel)]="course_model.certification"
                            checked />
                          <label for="certificationYes">Yes</label>
                        </div>
                      </li>
                      <li class="d-inline-block mr-2">
                        <div class="radio">
                          <input type="radio" value="false" formControlName="certification" name="certification" id="certificationNo"  [(ngModel)]="course_model.certification" />
                          <label for="certificationNo">No</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <label for="live_projects">Live Projects?</label>
                    <ul class="list-unstyled mb-0">
                      <li class="d-inline-block mr-2">
                        <div class="radio">
                          <input type="radio" value="yes" name="live_projects" formControlName="live_projects" id="live_projectsYes"  [(ngModel)]="course_model.live_projects"
                            checked />
                          <label for="live_projectsYes">Yes</label>
                        </div>
                      </li>
                      <li class="d-inline-block mr-2">
                        <div class="radio">
                          <input type="radio" value="no" formControlName="live_projects" name="live_projects" id="live_projectsNo" [(ngModel)]="course_model.live_projects" />
                          <label for="live_projectsNo">No</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="d-flex flex-sm-row flex-column justify-content-end">
                  <button type="button" class="btn btn-secondary mr-sm-2 mb-1" (click)="setActiveTab('basic')">Previous</button>
                  <button type="submit" class="btn btn-primary mb-1" (click)="setActiveTab('pricing')">Next</button>
                </div>
              </form>
            </div>

            <!-- pricing Tab -->
            <div class="tab-pane" [ngClass]="{active: activeTab === 'pricing'}" id="pricing" role="tabpanel"
              aria-labelledby="pricing-tab">
              <form [formGroup]="pricingForm" (ngSubmit)="onPricingFormSubmit()">
                <div class="row">
                  <div class="col-12 form-group">
                    <label for="total_fees">Total Fees<span class="required_field">*</span></label>
                    <div class="controls">
                      <input formControlName="total_fees" [(ngModel)]="course_model.total_fees" type="number" class="form-control" required
                        placeholder="Total Fees"
                        [ngClass]="{ 'is-invalid': pricingFormSubmitted && pf.total_fees.invalid, 'is-valid': pricingFormSubmitted && !pf.total_fees.invalid }"
                        >
                      <!-- <div *ngIf="pricingFormSubmitted && (pf.total_fees.invalid || pf.total_fees.errors?.required)"
                        class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                        required</div> -->
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label for="min_fees">Min Fees</label>
                    <div class="controls">
                      <input formControlName="min_fees" [(ngModel)]="course_model.minfees" type="number" class="form-control" required
                        placeholder="Min Fees"
                        [ngClass]="{ 'is-invalid': pricingFormSubmitted && pf.min_fees.invalid, 'is-valid': pricingFormSubmitted && !pf.min_fees.invalid }"
                        >
                      <div *ngIf="pricingFormSubmitted && (pf.min_fees.invalid || pf.min_fees.errors?.required)"
                        class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                        required</div>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label for="max_fees">Max Fees</label>
                    <div class="controls">
                      <input formControlName="max_fees" [(ngModel)]="course_model.maxfees" type="number" class="form-control" required
                        placeholder="Max Fees"
                        [ngClass]="{ 'is-invalid': pricingFormSubmitted && pf.max_fees.invalid, 'is-valid': pricingFormSubmitted && !pf.max_fees.invalid }"
                        >
                      <div *ngIf="pricingFormSubmitted && (pf.max_fees.invalid || pf.max_fees.errors?.required)"
                        class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                        required</div>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label>offers</label>
                    <div class="controls">
                      <input formControlName="offer" [(ngModel)]="course_model.offer" type="number" class="form-control" required
                        placeholder="offer"
                        [ngClass]="{ 'is-invalid': pricingFormSubmitted && pf.offer.invalid, 'is-valid': pricingFormSubmitted && !pf.offer.invalid }"
                        >
                      <div *ngIf="pricingFormSubmitted && (pf.offer.invalid || pf.offer.errors?.required)"
                        class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                        required</div>
                    </div>
                    <!-- <ng-select [items]="offers_list" bindLabel="displayname" bindValue="_id"
                      placeholder="Select offers" [(ngModel)]="selected_discount"
                      [ngModelOptions]="{ standalone: true }" (change)="getDiscountId($event)">
                    </ng-select> -->
                  </div>
                  <div class="col-12 form-group">
                    <label for="serviceandoffer">Service & Offers</label>
                    <div class="controls">
                      <quill-editor formControlName="serviceandoffer" [(ngModel)]="course_model.serviceandoffer" [maxLength]="5" [minLength]="3" [required]="true"
                        [modules]="{toolbar: false}"
                        [ngClass]="{ 'ng-invalid-textArea': pricingFormSubmitted && pf.serviceandoffer.invalid, 'is-valid': pricingFormSubmitted && !pf.serviceandoffer.invalid }"></quill-editor>
                      <div *ngIf="pricingFormSubmitted && (pf.serviceandoffer.invalid || pf.serviceandoffer.errors.required)"
                        class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                        required</div>
                        <div *ngIf="pricingFormSubmitted && pf.serviceandoffer.errors?.minlength" class="help-block mt-1 text-danger">
                          <i class="ft-alert-circle align-middle"></i> Minimum length is 3 characters
                      </div>
                    </div>
                  </div>
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                    <button type="button" class="btn btn-secondary mr-sm-2 mb-1" (click)="setActiveTab('advance')">Previous</button>
                    <button type="submit" class="btn btn-primary mb-1" (click)="setActiveTab('publishing')">Next</button>
                    
                  </div>
                </div>
              </form>
            </div>

            <!-- Social Links Tab -->
            <div class="tab-pane" [ngClass]="{active: activeTab === 'publishing'}" id="publishing" role="tabpanel"
              aria-labelledby="publishing-tab">
              <form [formGroup]="publishingForm" (ngSubmit)="onPublishingFormSubmit()">
                <div class="row">
                  <div class="col-12 form-group">
                    <label for="published_datetime">Published Date Time<span class="required_field">*</span></label>
                    <div class="controls">
                      <!-- <input ngbDatepicker (click)="datePicker.toggle()" #datePicker="ngbDatepicker"
                        formControlName="published_datetime" type="text" class="form-control pickadate" required
                        [ngClass]="{ 'is-invalid': publishFormSubmitted && pbf.published_datetime.invalid, 'is-valid': publishFormSubmitted && !pbf.published_datetime.invalid }"
                        placeholder="Published Date Time"> -->
                        <input type="datetime-local" class="form-control"  formControlName="published_datetime" id="published_datetime" [(ngModel)]="course_model.published_datetime"
                      placeholder="Enter published_datetime" [ngClass]="{ 'is-invalid': publishFormSubmitted && pbf.published_datetime.invalid, 'is-valid': publishFormSubmitted && !pbf.published_datetime.invalid }"/>
                      <div *ngIf="publishFormSubmitted && (pbf.published_datetime.invalid || pbf.published_datetime.errors?.required)"
                        class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                        required</div>
                    </div>
                  </div>
                  <div class="col-12 radio-fields">
                    <div>
                      <label for="published_web">Web Published?</label>
                      <ul class="list-unstyled mb-0">
                        <li class="d-inline-block mr-2">
                          <div class="radio" >
                            <input type="radio" [value]="true" name="published_web" formControlName="published_web" [(ngModel)]="course_model.published_web" id="published_webYes"
                            #radioWebyes />
                            <label for="published_webYes">Yes</label>
                          </div>
                        </li>
                        <li class="d-inline-block mr-2">
                          <div class="radio">
                            <input type="radio" [value]="false" formControlName="published_web" name="published_web" id="published_webNo" [(ngModel)]="course_model.published_web"  />
                            <label for="published_webNo">No</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <label for="published_app">Mobile Published?</label>
                      <ul class="list-unstyled mb-0">
                        <li class="d-inline-block mr-2">
                          <div class="radio">
                            <input type="radio"  [value]="true" name="published_app" formControlName="published_app" id="published_appYes" [(ngModel)]="course_model.published_app" 
                              checked #radioMobileyes />
                            <label for="published_appYes">Yes</label>
                          </div>
                        </li>
                        <li class="d-inline-block mr-2">
                          <div class="radio">
                            <input type="radio" [value]="false" formControlName="published_app" name="published_app" id="published_appNo" [(ngModel)]="course_model.published_app"  />
                            <label for="published_appNo">No</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label>course tags<span class="required_field">*</span></label>
                    <ng-select [items]="courseTagsList" [multiple]="true" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Course Tags" [(ngModel)]="selectedCourseTag"
                      [ngModelOptions]="{ standalone: true }" (change)="getCourseTagId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label class="form-control-label" for="Employeetype">
                      Category Tags<span class="required_field">*</span>
                     </label>
                     <ng-select
                       [items]="category_tags_list"
                       bindLabel="displayname"
                       bindValue="_id"
                       placeholder="Select Category Tags"
                       [(ngModel)]="selected_category_tags"
                       [ngModelOptions]="{ standalone: true }"
                       (change)="getCategoryTagsId($event)"
                       [multiple]="true"
                     >
                     </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label class="form-control-label" for="Employeetype">
                      Publish Category<span class="required_field">*</span>
                     </label>
                     <ng-select
                       [items]="publish_category_list"
                       bindLabel="displayname"
                       bindValue="_id"
                       placeholder="Select Category"
                       [(ngModel)]="selected_publish_category"
                       [ngModelOptions]="{ standalone: true }"
                       (change)="getPublishCategoryId($event)"
                     >
                     </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label class="form-control-label" for="Employeetype">
                      Publish Tags<span class="required_field">*</span>
                     </label>
                     <ng-select
                       [items]="publish_tags_list"
                       bindLabel="displayname"
                       bindValue="_id"
                       placeholder="Select Tag"
                       [(ngModel)]="selected_publish_tag"
                       [ngModelOptions]="{ standalone: true }"
                       (change)="getPublishTagId($event)"
                     >
                     </ng-select>
                  </div>
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                    <button type="button" class="btn btn-secondary mr-sm-2 mb-1" (click)="setActiveTab('pricing')">Previous</button>
                    <button type="button" [disabled]="!selected_publish_category && !selected_publish_tag" class="btn btn-primary mb-1" (click)="setActiveTab('team')">Next</button>
                  </div>
                </div>
              </form>
            </div>

            <!-- team Tab -->
            <div class="tab-pane" [ngClass]="{active: activeTab === 'team'}" id="team" role="tabpanel"
              aria-labelledby="team-tab">
              <form novalidate>
                <div class="row">
                  <div class="col-12 form-group">
                    <label>Instructor<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select instructor" [(ngModel)]="selected_instructor"
                      [ngModelOptions]="{ standalone: true }" [multiple]="true" (change)="getinstructorId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label>Proof readers<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select proof readers" [(ngModel)]="selected_proofread"
                      [ngModelOptions]="{ standalone: true }" [multiple]="true" (change)="getProofreadId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label>Publishers<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select publishers" [(ngModel)]="selected_publisher"
                      [ngModelOptions]="{ standalone: true }" [multiple]="true" (change)="getPublisherId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label>last published by<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select last publishers" [(ngModel)]="selected_last_publisher"
                      [ngModelOptions]="{ standalone: true }" (change)="getLastPublisherId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                    <button type="button" class="btn btn-secondary mr-sm-2 mb-1" (click)="setActiveTab('publishing')">Previous</button>
                    <button type="button" class="btn btn-primary mb-1" (click)="setActiveTab('admin')">Next</button>
                  </div>
                </div>
              </form>
            </div>
            <!-- Meta Tab -->
            <div *ngIf="courseId" class="tab-pane" [ngClass]="{active: activeTab === 'meta'}" id="meta" role="tabpanel" aria-labelledby="meta-tab">
              <form novalidate>
                <div class="row">
                  <div>
                    <button  class="btn btn-primary my-1" (click)="addMeta(courseId)">Add Meta</button>
                  </div>
                  <!-- <div *ngIf="meta_data?.meta_title">
                    <span><b>Meta Title :</b> {{course_model?.meta_title}} </span><br>
                    <span><b>Meta Keywords :</b> {{course_model?.meta_keywords}} </span><br>
                    <span><b>Meta Description :</b> {{course_model?.meta_descriptions}} </span><br>
                    <span><b>Colonical Tags :</b> {{course_model?.canonical}} </span><br>
                    <span><b>OG Tags :</b> <br>
                    <span><b>Title</b> : {{course_model?.og_tags?.title}}</span> <br>
                    <span><b>Site Name</b> : {{course_model?.og_tags?.site_name}}</span> <br>
                    <span><b>Description</b> : {{course_model?.og_tags?.description}}</span> <br>
                    </span>
                  </div> -->

                  <div class="col-12 form-group">
                    <label>Meta Title<span class="required_field">*</span></label>
                    <input type="text"  [(ngModel)]="meta_data.meta_title" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="Meta Title" >
                  </div>
                  <div class="col-12 form-group">
                    <label>Meta Keywords<span class="required_field">*</span></label>
                    <input type="text" [(ngModel)]="meta_data.meta_keywords" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="Meta Keywords">
                  </div>
                  <div class="col-12 form-group">
                    <label>Meta Description<span class="required_field">*</span></label>
                    <textarea name="meta_descriptions" [(ngModel)]="meta_data.meta_description" [ngModelOptions]="{standalone: true}" class="form-control" id="meta_descriptions"></textarea>
                  </div>
                  <div class="col-12 form-group">
                    <label>Colonical Tags<span class="required_field">*</span></label>
                    <input type="text" [(ngModel)]="meta_data.canonical" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="Colonical Tags ">
                  </div>
                  <div class="col-12 form-group">
                    <b>OG Tags</b>
                  </div>
                  <div class="col-12 form-group">
                    <label>Title<span class="required_field">*</span></label>
                    <input type="text" [(ngModel)]="meta_data.og_tags.title" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="Title">
                  </div>
                  <div class="col-12 form-group">
                    <label>Site Name<span class="required_field">*</span></label>
                    <input type="text" [(ngModel)]="meta_data.og_tags.site_name" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="Site Name">
                  </div>
                  <div class="col-12 form-group">
                    <label>Description<span class="required_field">*</span></label>
                    <textarea name="description" [(ngModel)]="meta_data.og_tags.description" [ngModelOptions]="{standalone: true}"
                      class="form-control" id="meta_descriptions"></textarea>
                  </div>
                  <div class="col-12 form-group">
                    <label>Image<span class="required_field">*</span></label>
                    <input type="text" [(ngModel)]="meta_data.og_tags.image" [ngModelOptions]="{standalone: true}"
                      class="form-control" placeholder="image">
                  </div>
                  <div class="col-12 form-group">
                    <label>Url<span class="required_field">*</span></label>
                    <input type="text" [(ngModel)]="meta_data.og_tags.url" [ngModelOptions]="{standalone: true}" class="form-control"
                      placeholder="url">
                  </div>
                  <div class="col-12 form-group">
                    <label>Type<span class="required_field">*</span></label>
                    <input type="text" [(ngModel)]="meta_data.og_tags.type" [ngModelOptions]="{standalone: true}" class="form-control"
                      placeholder="type">
                  </div>
                  <!-- <div class="col-12 form-group">
                    <label>Proof readers<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select proof readers" [(ngModel)]="selected_proofread" [ngModelOptions]="{ standalone: true }"
                      [multiple]="true" (change)="getProofreadId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label>Publishers<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid" placeholder="Select publishers"
                      [(ngModel)]="selected_publisher" [ngModelOptions]="{ standalone: true }" [multiple]="true"
                      (change)="getPublisherId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label>last published by<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select last publishers" [(ngModel)]="selected_last_publisher"
                      [ngModelOptions]="{ standalone: true }" (change)="getLastPublisherId($event)">
                    </ng-select>
                  </div> -->
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                    <button type="button" class="btn btn-secondary mr-sm-2 mb-1"
                      (click)="setActiveTab('publishing')">Previous</button>
                    <button type="button" class="btn btn-primary mb-1" (click)="setActiveTab('admin')">Next</button>
                  </div>
                </div>
              </form>
            </div>

            <!-- admin Tab -->
            <div class="tab-pane" [ngClass]="{active: activeTab === 'admin'}" id="admin" role="tabpanel"
              aria-labelledby="admin-tab">
              <form [formGroup]="adminForm" (ngSubmit)="onAdminFormSubmit()">
                <div class="row">
                  <div class="col-12 form-group">
                    <label>Batch<span class="required_field">*</span></label>
                    <ng-select [items]="batchList" bindLabel="name" bindValue="_id" placeholder="Select Batch"
                      [(ngModel)]="selectedBatch" [ngModelOptions]="{ standalone: true }" (change)="getBatchId($event)">
                    </ng-select>
                  </div>
                  <div class="col-12 form-group">
                    <label for="announcements">Announcement</label>
                    <div class="controls">
                      <quill-editor formControlName="announcements" [(ngModel)]="course_model.announcements"  [maxLength]="5" [minLength]="3" [required]="true"
                        [modules]="{toolbar: false}"
                        ></quill-editor>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label for="notes">Notes</label>
                    <div class="controls">
                      <quill-editor formControlName="notes" [(ngModel)]="course_model.notes" [maxLength]="5" [minLength]="3" [required]="true"
                        [modules]="{toolbar: false}"
                        ></quill-editor>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label>Admin Notes</label>
                    <div class="controls">
                      <quill-editor formControlName="admin_notes" [(ngModel)]="course_model.admin_notes" [maxLength]="5" [minLength]="3" [required]="true"
                        [modules]="{toolbar: false}"
                        ></quill-editor>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label>Read Password<span class="required_field">*</span></label>
                    <div class="controls">
                      <input type="text" class="form-control" formControlName="password" [(ngModel)]="course_model.password" placeholder="Enter Password" [ngClass]="{ 'is-invalid': adminFormSubmitted && adf.password.invalid, 'is-valid': adminFormSubmitted && !adf.password.invalid }"
                      required>
                    <div *ngIf="adminFormSubmitted && (adf.password.invalid || adf.password.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                      required</div>
                    </div>
                  </div>
                  <div class="col-12 form-group">
                    <label>Write Password<span class="required_field">*</span></label>
                    <div class="controls">
                      <input type="text" class="form-control" formControlName="write_password" [(ngModel)]="course_model.write_password" placeholder="Enter write password" [ngClass]="{ 'is-invalid': adminFormSubmitted && adf.write_password.invalid, 'is-valid': adminFormSubmitted && !adf.write_password.invalid }"
                      required>
                    <div *ngIf="adminFormSubmitted && (adf.write_password.invalid || adf.write_password.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
                      required</div>
                    </div>
                  </div>
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                    <button type="button" class="btn btn-secondary mr-sm-2 mb-1" (click)="setActiveTab('team')">Previous</button>
                    <button type="button" class="btn btn-primary mb-1" (click)="submitCourse()">Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Account Settings ends -->

<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>